export const profileReducer = (state = { countries: [] ,states:[],cities:[],user:{}}, action) => {
  
  switch (action.type) {
    case 'GET_SEEKER_DETAILS':
      return {
        ...state,
        user:action.payload
      }

    case "GET_COUNTRY":
      return {
        ...state,
        countries: action.payload,
      };
    case 'GET_STATE':
    return {
        ...state,
        states:action.payload
    }
    case 'GET_CITY':
    return {
        ...state,
        cities:action.payload
    }
    default:
      return state;
  }
};
